export default {
  namespaced: true,

  state: {
    mapboxToken: '',
    mapboxStyle: '',
    mapboxUser: '',

    polygonPath: '',
  },

  getters: {
    mapboxConfig: (state) => ({
      accessToken: state.mapboxToken,
      style: state.mapboxStyle,
      user: state.mapboxUser,
    }),

    polygonPath: (state) => state.polygonPath,
  },

  /* eslint-disable no-param-reassign */
  mutations: {
    setMapboxOptions: (state, options) => {
      const { mapboxToken, mapboxStyle, mapboxUser, polygonPath } =
        options || {};

      state.mapboxToken = mapboxToken;
      state.mapboxStyle = mapboxStyle;
      state.mapboxUser = mapboxUser;
      state.polygonPath = polygonPath;
    },
  },

  actions: {
    initMapboxOptions: ({ commit }, options) => {
      commit('setMapboxOptions', options);
    },
  },
};
